import { Connection, Internal } from '../../PayItemsModuleContext/types'

export function getLabel(item: Internal | Connection) {
  if (item.__typename === 'ProjectToInternalConnection')
    return item.internal.module.name
  else if (item.__typename === 'PayItemConnection')
    return (
      item.name ??
      item.googleSheet?.title ??
      item.googleSheet?.compositeId ??
      'Connection'
    )
  return 'Connection'
}
